export enum SPOM4Directions {
  Right = 'Right',
  Left = 'Left',
}
